/* SAMPLE COLLECTORS */
export const GET_DISCOUNT_LABHAZIRTOLABS = "GET_DISCOUNT_LABHAZIR_TO_LABS";
export const GET_DISCOUNT_LABHAZIRTOLABS_SUCCESS =
  "GET_DISCOUNT_LABHAZIRTOLABS_SUCCESS";
export const GET_DISCOUNT_LABHAZIRTOLABS_FAIL = "GET_DISCOUNT_LABHAZIRTOLABS_FAIL";

export const UPDATE_DISCOUNT_LABHAZIRTOLAB = "UPDATE_DISCOUNT_LABHAZIRTOLAB";
export const UPDATE_DISCOUNT_LABHAZIRTOLAB_SUCCESS =
  "UPDATE_DISCOUNT_LABHAZIRTOLAB_SUCCESS";
export const UPDATE_DISCOUNT_LABHAZIRTOLAB_FAIL =
  "UPDATE_DISCOUNT_LABHAZIRTOLAB_FAIL";

export const UPDATE_DISCOUNT_ALL_LABHAZIRTOLAB = "UPDATE_DISCOUNT_ALL_LABHAZIRTOLAB";
export const UPDATE_DISCOUNT_ALL_LABHAZIRTOLAB_SUCCESS =
  "UPDATE_DISCOUNT_ALL_LABHAZIRTOLAB_SUCCESS";
export const UPDATE_DISCOUNT_ALL_LABHAZIRTOLAB_FAIL =
  "UPDATE_DISCOUNT_ALL_LABHAZIRTOLAB_FAIL";
